import { useAuth } from "@/components/shared/auth-provider";
import { app } from "@/config/env";
import { getIdentifiersFromStorage } from "@/lib/identifiers";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { useEffect, useState } from "react";
import { tokenManager } from "@/lib/token-manager";
import { rudderanalytics } from "@/lib/rudderstack";
import { GA_ID } from "@/constants";
import { getCookie } from "@/lib/cookie";
import { getPlatform } from "@/lib/utils";
import { getSalesPersonData } from "@/lib/get-sales-person-data";

export function navigateCrossDomainLinker(url: string) {
  const a = document.createElement("a");
  a.href = url;
  a.rel = "noopener";
  a.style.display = "none";
  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
}

function checkRedirectToNewLuceWebDomain(params: Record<string, string>) {
  if (
    getPlatform() === "web" &&
    app.NEW_LUCE_WEB_DOMAIN &&
    window.location.host !== app.NEW_LUCE_WEB_DOMAIN
  ) {
    const newLuceWebDomainUrl = new URL(window.location.href);
    newLuceWebDomainUrl.hostname = app.NEW_LUCE_WEB_DOMAIN;

    Object.entries(params).forEach(([key, values]) => {
      if (values) {
        newLuceWebDomainUrl.searchParams.set(key, values);
      }
    });

    const currentUrl = new URL(window.location.href);
    const gaLinker = currentUrl.searchParams.get("_gl");

    if (gaLinker) {
      newLuceWebDomainUrl.searchParams.set("_gl", gaLinker);
    }

    navigateCrossDomainLinker(newLuceWebDomainUrl.toString());
  }
}

async function getQueryParams() {
  const identifiers = await getIdentifiersFromStorage();
  const { distinct_id, session_id } = PosthogAnalytics.getIdentifiers();
  const ajs_aid = await rudderanalytics.getAnonymousId();
  const sales = getSalesPersonData();

  const gaId = getCookie(GA_ID);

  const params: Record<string, string> = {
    ...identifiers,
  };
  if (sales) {
    params.sales = sales;
  }
  if (distinct_id) {
    params.distinct_id = distinct_id;
  }
  if (session_id) {
    params.session_id = session_id;
  }
  if (ajs_aid) {
    params.ajs_aid = ajs_aid;
  }
  if (gaId) {
    params.gaid = gaId;
  }

  return params;
}

const isOnNewLuceWebDomain = () => {
  return (
    getPlatform() === "web" &&
    app.NEW_LUCE_WEB_DOMAIN &&
    window.location.host === app.NEW_LUCE_WEB_DOMAIN
  );
};

export const CheckRedirectToNewLuceWebDomain = () => {
  const { clientId, isLoading } = useAuth();

  const [queryParams, setQueryParams] = useState<Record<string, string> | null>(
    null,
  );

  useEffect(() => {
    if (isOnNewLuceWebDomain()) {
      return;
    }

    if (!isLoading && queryParams) {
      let tokenData = undefined;
      if (clientId) {
        tokenData = tokenManager.getTokenDecode(clientId);
      }

      checkRedirectToNewLuceWebDomain({ ...tokenData, ...queryParams });
    }
  }, [isLoading, queryParams]);

  useEffect(() => {
    if (isOnNewLuceWebDomain()) {
      return;
    }

    const timeout = setTimeout(() => {
      getQueryParams()
        .then((params) => {
          setQueryParams(params);
        })
        .catch((error) => {
          console.log("Failed to get query params for redirect:", error);
          setQueryParams({});
        });
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  return null;
};
